import { useSelector } from "react-redux";

export const useAdvanceSearchSelector = () => {
  return useSelector((state) => state.advanceSearch)
}
